/**
 * Reading the error envelope every api-* service returns.
 *
 * Deliberately its own module rather than living beside `gatewayFetch`: this is
 * a pure function of a Response and nothing should ever want to stub it, while
 * the transport is stubbed all over the test suite. Co-locating them meant a
 * `vi.mock('helpers/gateway')` silently removed this too.
 */

/**
 * The `message` from an api-users error body, or `''` when there is not one.
 *
 * Every api-* service answers a failure through the shared `errorHandler`, which
 * serialises `{ message, enum, data }` - and `enum` is only populated for a
 * returned error rather than a thrown one, so `message` is usually the only
 * thing carrying the reason. gatewayFetch resolves on a plain-fetch 4xx/5xx, so
 * the body is where a caller has to look; a gateway error page is not JSON, and
 * then the status is all there is.
 *
 * Shared because the envelope is one thing that changes as one thing: three
 * callers had byte-identical copies of this read, each mapping the message to
 * its own outcome. The mapping stays with the caller; only the read is here.
 */
export async function readErrorMessage(response: Response): Promise<string> {
	try {
		const body = await response.json();
		return typeof body?.message === 'string' ? body.message : '';
	} catch {
		return '';
	}
}
